import { Button, Select, Alert } from 'antd';
import classNames from 'classnames';
import { useState } from 'react';
import { AxiosAmbient } from 'src/lib';
import { FronteggContext } from '@frontegg/rest-api';
import { showToastSuccess } from 'src/utilities/toast';
import { showToastError } from 'src/utilities/errortoast';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';

const EncounterReport = () => {
  const { user } = useAuth();
  const [selectedDateRange, setSelectedDateRange] = useState('1days');
  const [isLoading, setIsLoading] = useState(false);

  const handleDateRangeChange = (value) => {
    setSelectedDateRange(value);
  };

  const handleSubmit = async () => {
    analytics.track('Clicked Generate Ad-Hoc Encounter Audit Report', {
      email: user?.email,
    });
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };

    const payload = {
      days_back: selectedDateRange.split('days')[0],
    };

    try {
      setIsLoading(true);
      const result = await AxiosAmbient.post('/encounter_report', payload, {
        headers,
      });
      if (result.status === 200) {
        showToastSuccess('Report generation request sent.');
      }
    } catch (error) {
      showToastError('Oops! Something went wrong.');
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex-1 pt-4">
      <div className="bg-white rounded-lg shadow-sm p-6">
        <div className="flex flex-col gap-3">
          <div className="text-lg font-bold font-sans pl-1 mb-2">
            Generate Encounter Report
          </div>
          <Alert
            message="Reports are generated daily at 2:00 AM Eastern Time and are sent to the SFTP server."
            description="To create an ad-hoc report, please select the time period and click the Generate Report button. The generated report will be available on the SFTP server within a few minutes."
            type="info"
            showIcon
          />
          <div className="flex flex-col gap-2">
            <div className="text-sm font-sans pl-1 mb-2">
              Select the time period for the encounter report
            </div>
            <div className="w-1/3">
              <Select
                value={selectedDateRange}
                onChange={handleDateRangeChange}
                style={{
                  borderColor: '#d9d9d9',
                  borderRadius: '6px',
                }}
                size="small"
                className={classNames(
                  'font-sans w-full border border-gray-200',
                  'hover:border-blue-400 focus:border-blue-400 rounded-md',
                  'single-select'
                )}
              >
                <Select.Option value="1days">Past 1 day</Select.Option>
                <Select.Option value="2days">Past 2 days</Select.Option>
                <Select.Option value="3days">Past 3 days</Select.Option>
                <Select.Option value="4days">Past 4 days</Select.Option>
                <Select.Option value="5days">Past 5 days</Select.Option>
              </Select>
            </div>
            <div className="flex justify-center w-full">
              <Button
                onClick={handleSubmit}
                loading={isLoading}
                className={classNames(
                  'mt-5  w-2/4 md:w-1/3 lg:w-1/3',
                  'ih-button-primary'
                )}
              >
                Generate report
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EncounterReport;
